export default "__VITE_ASSET__2cb28c04__"